<template>
  <div class="navmenu">
    <div class="contents navmenu-contents">
      <ul class="navmenu-ul">
        <li
          class="navmenu-li"
          v-for="(mulu, index) in navMenu"
          :key="index"
          @mouseover="toshow(index)"
          @mouseout="toshow(100)"
          :class="{ activie: selected(mulu.urllist) }"
        >
          <router-link :to="{ path: mulu.url }" tag="li">{{
            mulu.name
          }}</router-link>
          <ul
            class="navmenu-ul-son"
            :class="{ 'navmenu-ul-son-first': index == 0 }"
            v-if="mulu.list && mulu.list.length > 0"
            v-show="firstclass == index"
          >
            <li
              class="navmenu-li-son"
              v-for="(items, indexs) in mulu.list"
              @mouseover="toshows(indexs)"
              @mouseout="toshows(100)"
              :class="{ 'navmenu-li-son-active': secondaryclass == indexs }"
            >
              <a :href="items.url">{{ items.name }}</a>
              <!-- <ul
                class="navmenu-ul-son-son"
                v-if="items.list && items.list.length > 0"
                v-show="secondaryclass == indexs"
              >
                <li
                  v-for="(item, indexsx) in items.list"
                  class="navmenu-li-son-son"
                >
                  <a :href="item.url">{{ item.name }}</a>
                </li>
              </ul> -->
            </li>
          </ul>
          <ul
            class="navmenu-ul-son-son"
            v-if="index == 0"
            v-show="firstclass == index"
          >
            <li
              class="navmenu-li-son-p-son"
              v-for="(items, indexss) in mulu.list"
              @mouseover="toshows(indexss)"
              @mouseout="toshows(100)"
            >
              <span
                v-for="(item, indexsx) in items.list"
                class="navmenu-li-son-son"
              >
                <a :href="item.url">{{ item.name }}</a>
              </span>

              <!-- <ul
                class="navmenu-ul-son-son"
                v-if="items.list && items.list.length > 0"
                v-show="secondaryclass == indexs"
              >
                <li
                  v-for="(item, indexsx) in items.list"
                  class="navmenu-li-son-son"
                >
                  <a :href="item.url">{{ item.name }}</a>
                </li>
              </ul> -->
            </li>
          </ul>
        </li>
        <!-- <li class="navmenu-li activie">品&nbsp;牌</li>
            <li class="navmenu-li">服务行业</li>
            <li class="navmenu-li">关于我们</li>
            <li class="navmenu-li">帮&nbsp;助</li> -->
        <div class="clear"></div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      firstclass: 100,
      secondaryclass: 100,
      navMenu: []
    };
  },
  methods: {
    getgoodslist() {
      //重新获取数据
      const res = this.$api.index.getMulu();
      this.navMenu = res;
    },
    toshow(val) {
      //console.log(val);
      this.firstclass = val;
    },
    toshows(val) {
      this.secondaryclass = val;
    },
    selected: function(urlinfo) {
      //console.log(urlinfo)
      return urlinfo.indexOf(this.$route.name) !== -1;
    }
  },
  mounted() {
    this.getgoodslist();
  }
};
</script>

<style scoped>
.navmenu {
  background-color: #2655ae;
  font-size: 16px;
}
.navmenu-contents {
  height: 38px;
}
.navmenu-li {
  position: relative;
  width: 240px;
  line-height: 38px;
  float: left;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
/* .navmenu-li a {
  padding: 0 10px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #666;
  line-height: 38px;
  background-repeat: no-repeat;
  background-position: right center;
} */
.navmenu-li-son {
  width: 157px;
}
.navmenu-li-son a {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #666;
  line-height: 38px;
  background-repeat: no-repeat;
  background-position: right center;
  width: 117px;
  text-align: left;
}
.navmenu-li-son-p-son a {
  vertical-align: middle;
  font-size: 14px;
  color: #666;
  line-height: 38px;
}
.navmenu-li-son-son {
  margin-right: 20px;
}
.navmenu-li-son a:hover {
  color: #2655ae;
  background-image: url(/static/icon/icon-next.png);
}
.navmenu-li-son-active a {
  color: #333;
  background-image: url(/static/icon/icon-next.png);
}
.navmenu-li-son-son a:hover {
  color: #2655ae;
}
.navmenu-li:hover::after {
  position: absolute;
  content: " ";
  left: 70px;
  top: 35px;
  width: 100px;
  z-index: 2022;
  border-bottom: 3px solid #fbb113;
  background-size: 100% 100%;
}
.navmenu-li.activie:hover::after {
  display: none;
}
.navmenu-li ul {
  z-index: 2022;
}
.navmenu-li-son {
  position: relative;
}
.navmenu-ul-son {
  position: absolute;
  left: 45px;
  top: 38px;
  width: 157px;
  background-color: #fff;
  color: #333;
  box-shadow: 0px 0px 8px rgba(72, 72, 72, 0.2);
  padding-top: 12px;
  padding-bottom: 12px;
}
.navmenu-ul-son-first {
  left: 0;
}
.navmenu-ul-son-son {
  position: absolute;
  left: 157px;
  top: 38px;
  width: 1028px;
  background-color: #fff;
  color: #333;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 15px;
  text-align: left;
}
/* .navmenu-ul-son-son {
  position: absolute;
  left: 140px;
  top: 0;
  width: 150px;
  background-color: #fff;
  color: #333;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
} */
.navmenu-ul .activie {
  background-color: #fbb113;
}
</style>



// WEBPACK FOOTER //
// src/components/common/NavMenu.vue